export default "__VITE_PUBLIC_ASSET__a88afc36__"